const DEFAULT_PREVIEW_MODULES_PATH = '/preview/modules/';

/**
 * Creates a getHref function that conditionally rewrites module URLs
 * to use preview paths.
 *
 * @param configPreview - Whether the hub is globally in preview mode
 * @param previewModulesPath - Replacement for `/modules/` in preview hrefs.
 *   Defaults to `/preview/modules/`; legacy hosts may pass `/modules/preview/`.
 */
export function createGetHref(
  configPreview: boolean,
  previewModulesPath = DEFAULT_PREVIEW_MODULES_PATH,
) {
  return function getHref(
    href?: string | null,
    preview = false,
  ): string | null {
    if (!href) return null;
    if (configPreview || preview) {
      if (href.indexOf('preview') < 0) {
        href = href.replace('/modules/', previewModulesPath);
      }
    }
    return href;
  };
}
